import axios from "axios";
import ApiConfig from "../../Utils/Configs/apiConfig";

export const deleteClientApi = async (userId: string) => {
    console.log("Deleting client with userId:", userId);
  try {
    const response = await  ApiConfig.getInstance().delete(`/Account/delete-client/${userId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error deleting client:", error);
    throw error.response?.data || error.message;
  }
};
